import { Timeline } from "primereact/timeline";
import { formatGtfsTimeString, gtfsTimeStringToSeconds } from "../../helpers/gtfsDateUtils";
import { useNewGtfsResource, useQueryGtfsResourceById } from "../../Queries";
import { PlatformIndicator } from "../../components/PlatformIndicator";
import { useState } from "react";
import { Button } from 'primereact/button';
        


export function TripsStopTimesEditor({tripId}) {
    const [dialog, setDialog] = useState(null);
    const {data, error, isPending} = useQueryGtfsResourceById('stop_times',tripId);

    if (!data || error || isPending) return;

    function findPreviousItem(data, item) {
        const index = data.indexOf(item);
    
        if (index > 0) {
            return data[index - 1];
        } else {
            return null; // Zwraca null, jeśli obiekt docelowy znajduje się na początku lub nie istnieje w tablicy
        }
    }

    const stopTimePrompt =  <div className="komin-stop-times-add">
        <Button raised size="small" icon="fa-solid fa-square-plus" severity="success" style={{transform: 'translateY(-25%)', padding: '0'}}/>
    </div>

    return (
        <>
            {stopTimePrompt}
            <Timeline 
                className="pb-4"
                value={data} 
                dataKey='kid'
                content={(item) => <div className="relative h-full">
                    {
                        item.kid !== data[0].kid
                            &&  <div className="absolute text-xs text-color-secondary" style={{left: '-3rem', top: '-2rem'}} >
                                    + {
                                        findPreviousItem(data,item) && ((gtfsTimeStringToSeconds(item.arrival_time) - gtfsTimeStringToSeconds(findPreviousItem(data,item).departure_time)) / 60 )
                                    } min.
                                </div>
                    }
                    {item.stop_name} 
                    <PlatformIndicator platformCode={item.platform_code} />
                    <span className="inline-block text-200 text-xs ml-2">{item.stop_id}</span>
                    {stopTimePrompt}
                </div>}
                opposite={(item) => <small>
                        {item.arrival_time !== item.departure_time ? <div>{formatGtfsTimeString(item.arrival_time)}</div> : ''}
                        <div>{formatGtfsTimeString(item.departure_time)}</div>
                    </small>
                }
                pt={{
                    opposite: {
                        style: {
                            flex: '0.24'
                        }
                    }
                }}
            />
        </>
    )
}